// extracted by mini-css-extract-plugin
module.exports = {"primaryFacet":"PrimaryFacet_primaryFacet__gVe1X","mobile":"PrimaryFacet_mobile__3GVM4","tablet":"PrimaryFacet_tablet__1XDR1","filterIcon":"PrimaryFacet_filterIcon__Ps_ty"};